import CrudBaseService from "@/services/CrudBaseService";

export default class QuoteReasonService extends CrudBaseService {
  constructor() {
    super('odoo/quote_reason');
  }

  findAll() {
    return this.http.get(`${this._serviceName}/`);
  }

  findAllByBenefit(benefitId) {
    return this.http.get(`${this._serviceName}/benefit/`+benefitId);
  }
}
